/**
 * Skeleton placeholders for app-like loading (lists, cards).
 */

interface SkeletonProps {
  className?: string;
}

export function Skeleton({ className = "" }: SkeletonProps) {
  return (
    <div
      className={`animate-pulse rounded-lg bg-slate-200/60 ${className}`}
      aria-hidden
    />
  );
}

/** Single list-row skeleton (image + lines). */
export function ListRowSkeleton() {
  return (
    <div className="flex items-center gap-3 min-h-[72px] px-4 py-3">
      <Skeleton className="w-14 h-14 flex-shrink-0 rounded-xl" />
      <div className="flex-1 min-w-0 space-y-2">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-3 w-1/2" />
        <Skeleton className="h-3 w-1/3" />
      </div>
    </div>
  );
}

/** N list row skeletons. */
export function ListSkeleton({ count = 5 }: { count?: number }) {
  return (
    <div className="divide-y divide-slate-100">
      {Array.from({ length: count }, (_, i) => (
        <ListRowSkeleton key={i} />
      ))}
    </div>
  );
}
